module.exports = __webpack_public_path__ + "img/gjbged.421d2d53.png";